import { TableCell, Typography } from "@mui/material"
import { AppColors } from "resources/AppColors"

const TableHeaderRowMonitoring = ({ title, ...props }) =>
  <TableCell align="left" variant="head" {...props} >
    <Typography variant='subtitle_bold' sx={{ fontSize: "14px", color: AppColors.WHITE }}>{title}</Typography>
  </TableCell>

export default TableHeaderRowMonitoring